import * as React from "react"
import { Link } from "gatsby"
import { hasSection, isOnePage, scrollToSection } from "./scroll"

/*
 * A link from inside body copy to a section of the one-pager.
 *
 * Copy that points at a section in its *own* section can use a plain
 * `<a href="#malharia">` — Produtos does, for its three ficha-técnica lines —
 * because the target is in the document either way, on `/` and on the legacy
 * route alike. This is for the case that is not true of: Sobre naming Amaré,
 * where `#amare` is on the home page but not on `/about/`.
 *
 * So the href is `/#amare`, which resolves from anywhere, and the click is
 * intercepted when the section turns out to be in the current document — the
 * same trade the navbar makes. Smooth scroll on the one-pager, a real
 * navigation from anywhere else.
 *
 * The navbar keeps its own handler rather than using this: it also has to
 * close the collapsed menu and wait for it before scrolling, and set the
 * highlighted item. All three share the actual scrolling, in scroll.js.
 */
export default function SectionLink({ id, className, children }) {
  const onClick = event => {
    if (!isOnePage()) return
    /* Let the browser have modified clicks — open-in-new-tab still works. */
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
    if (!hasSection(id)) return

    event.preventDefault()
    scrollToSection(id)

    /* Same as the navbar: keep the URL linkable without pushing an entry per
       click, and hand reach-router's state object straight back so Gatsby's
       scroll restoration keeps its key. */
    window.history.replaceState(window.history.state, "", "#" + id)
  }

  return (
    <Link to={`/#${id}`} className={className} onClick={onClick}>
      {children}
    </Link>
  )
}
